export default __webpack_public_path__ + "static/media/Shatush of the First Circle.813ff43d.jpg";